import makeStyles from '@mui/styles/makeStyles';
import { SIDEBAR_STEP_MAX_WIDTH } from '../../helpers/constants';

export const createClasses = makeStyles(theme => ({
  container: {
    maxWidth: SIDEBAR_STEP_MAX_WIDTH,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  subtitle: {
    color: theme.palette.primary[400]
  }
}));
